import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as models from '../../../models'

@ngCore.Component({
  imports: [],
  selector: 'cell-renderer',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component<
  TTypeParams extends
    ec.models.TypeParams.Constraint = ec.models.TypeParams.Constraint,
> implements ngCore.OnDestroy
{
  /** @see {@link ngCore.ViewContainerRef} */
  private readonly _container = ngCore.inject(ngCore.ViewContainerRef)

  /** TODO:  */
  public readonly cellConfigSg = ngCore.input.required<
    models.config.Cell.Applied<TTypeParams>
  >({
    alias: 'cellConfig',
  })

  /** TODO:  */
  private readonly _destroyed$ = new rxjs.Subject<void>()

  constructor() {
    ngCore.effect(() => {
      const { component, inputs, outputs, css } = this.cellConfigSg()

      // clear container if it has any content
      this._container.clear()
      const componentRef = this._container.createComponent(component)

      //  bind all the inputs
      if (inputs) {
        for (const input in inputs) {
          componentRef.setInput(input, inputs[input])
        }
      }

      // apply css
      if (css) {
        const element = componentRef.location.nativeElement as HTMLElement

        Object.assign(element.style, css)
      }

      // bind all the outputs
      if (outputs) {
        for (const output in outputs) {
          const callback: (typeof outputs)[typeof output] = outputs[output]
          // FIXME: this should be fixed for both signal and observable outputs
          const outputObservable: rxjs.Observable<any> =
            componentRef.instance[output]

          outputObservable
            .pipe(rxjs.takeUntil(this._destroyed$))
            .subscribe(data => {
              if (callback) {
                callback(data)
              }
            })
        }
      }
    })
  }

  ngOnDestroy(): void {
    this._destroyed$.next()
    this._destroyed$.complete()
  }
}
